// PartA2SelfEvaluation.js - Self-Evaluation component for Part A2
import React from 'react';
import { Input, Slider, Row, Col } from 'antd';

const PartA2SelfEvaluation = ({ formData, handleInputChange, handleArrayInputChange }) => {
    return (
        <div className="a4-page font-[poppins] bg-white p-8 mx-auto text-[#333333]" style={{ maxWidth: '100%', width: '100%' }}>
            {/* Header */}
            <div className="text-center mb-6">
                <h2 className="text-xl font-bold text-[#F97316] mb-1">PART A (2)</h2>
                <h3 className="text-lg font-bold text-black">Self-Evaluation</h3>
            </div>

            {/* Performance Evaluation Table */}
            <div className="mb-6 border-2 border-black">
                <div className="border-b-2 border-black bg-gray-200 p-2 text-center font-semibold text-sm">
                    Circle the most appropriate option.
                </div>
                <div className="flex">
                    {/* Left Column */}
                    <div className="w-1/2 border-r-2 border-black p-4 bg-[#DBEAFE]/30">
                        <p className="mb-4 font-medium text-sm">Last year, my performance at school was...</p>
                        <div className="flex items-center justify-between gap-2">
                            <span className="text-xs font-semibold text-red-500 whitespace-nowrap">← Poor</span>
                            <div className="flex-1 relative mx-2">
                                <div className="h-2 w-full rounded-full bg-gradient-to-r from-red-500 via-yellow-400 to-green-500"></div>
                                <Slider
                                    min={1}
                                    max={10}
                                    value={formData.last_year_performance || 5}
                                    onChange={(value) => handleInputChange('last_year_performance', value)}
                                    tooltip={{ open: true }}
                                    className="absolute -top-[5px] w-full m-0 [&_.ant-slider-track]:bg-transparent [&_.ant-slider-rail]:bg-transparent [&_.ant-slider-handle]:border-2 [&_.ant-slider-handle]:border-white [&_.ant-slider-handle]:bg-blue-600 [&_.ant-slider-handle]:opacity-100 [&_.ant-slider-handle]:w-4 [&_.ant-slider-handle]:h-4 [&_.ant-slider-handle]:mt-[-5px]"
                                />
                            </div>
                            <span className="text-xs font-semibold text-green-600 whitespace-nowrap">Excellent →</span>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="w-1/2 p-4 bg-[#DBEAFE]/30">
                        <p className="mb-4 font-medium text-sm">My teachers thought my efforts last year were...</p>
                        <div className="flex items-center justify-between gap-2">
                            <span className="text-xs font-semibold text-red-500 whitespace-nowrap">← Poor</span>
                            <div className="flex-1 relative mx-2">
                                <div className="h-2 w-full rounded-full bg-gradient-to-r from-red-500 via-yellow-400 to-green-500"></div>
                                <Slider
                                    min={1}
                                    max={10}
                                    value={formData.teacher_thought_efforts || 5}
                                    onChange={(value) => handleInputChange('teacher_thought_efforts', value)}
                                    tooltip={{ open: true }}
                                    className="absolute -top-[5px] w-full m-0 [&_.ant-slider-track]:bg-transparent [&_.ant-slider-rail]:bg-transparent [&_.ant-slider-handle]:border-2 [&_.ant-slider-handle]:border-white [&_.ant-slider-handle]:bg-blue-600 [&_.ant-slider-handle]:opacity-100 [&_.ant-slider-handle]:w-4 [&_.ant-slider-handle]:h-4 [&_.ant-slider-handle]:mt-[-5px]"
                                />
                            </div>
                            <span className="text-xs font-semibold text-green-600 whitespace-nowrap">Excellent →</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* New Things and Improvements */}
            <div className="mb-6 bg-[#DBEAFE]/30 p-0">
                <div className="flex">
                    <div className="w-1/2 p-4 border-r border-white">
                        <label className="block font-bold text-sm mb-2">This year, I will try new things like...</label>
                        <Input.TextArea
                            value={formData.try_new_things}
                            onChange={(e) => handleInputChange('try_new_things', e.target.value)}
                            className="bg-white border border-gray-300 rounded p-2 text-sm min-h-[80px]"
                            placeholder="Type here..."
                            autoSize={{ minRows: 3, maxRows: 3 }}
                        />
                    </div>
                    <div className="w-1/2 p-4">
                        <label className="block font-bold text-sm mb-2">I will work harder on things like...</label>
                        <Input.TextArea
                            value={formData.work_harder_on}
                            onChange={(e) => handleInputChange('work_harder_on', e.target.value)}
                            className="bg-white border border-gray-300 rounded p-2 text-sm min-h-[80px]"
                            placeholder="Type here..."
                            autoSize={{ minRows: 3, maxRows: 3 }}
                        />
                    </div>
                </div>
            </div>

            {/* Career Aspirations */}
            <div className="mb-6 border-2 border-[#2563EB] rounded-lg overflow-hidden">
                <div className="flex border-b-2 border-[#2563EB] bg-[#DBEAFE]">
                    <div className="w-1/2 p-2 text-center font-bold text-sm border-r-2 border-[#2563EB]">
                        My career aspirations is/are
                    </div>
                    <div className="w-1/2 p-2 text-center font-bold text-sm">
                        To fulfill my aspirations, I need to
                    </div>
                </div>
                <div className="flex bg-[#DBEAFE]/20">
                    <div className="w-1/2 p-4 border-r-2 border-[#2563EB]">
                        {(formData.career_aspirations || ['', '', '', '']).map((aspiration, index) => (
                            <div key={index} className="flex items-center mb-2 last:mb-0">
                                <span className="font-bold text-[#2563EB] mr-2 w-5">{index + 1}.</span>
                                <Input
                                    value={aspiration}
                                    onChange={(e) => handleArrayInputChange('career_aspirations', index, e.target.value)}
                                    className="border-b border-gray-400 bg-transparent rounded-none px-1 py-0.5 focus:shadow-none focus:border-blue-500 text-sm"
                                    bordered={false}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="w-1/2 p-4">
                        {(formData.to_fulfill_aspirations || ['', '', '', '']).map((requirement, index) => (
                            <div key={index} className="flex items-center mb-2 last:mb-0">
                                <span className="font-bold text-[#2563EB] mr-2 w-5">{index + 1}.</span>
                                <Input
                                    value={requirement}
                                    onChange={(e) => handleArrayInputChange('to_fulfill_aspirations', index, e.target.value)}
                                    className="border-b border-gray-400 bg-transparent rounded-none px-1 py-0.5 focus:shadow-none focus:border-blue-500 text-sm"
                                    bordered={false}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PartA2SelfEvaluation;